module.exports = "/images/Obstacle Course.svg?a3d9974c18bacf3e5ddc1915349fa082";